module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.327790cb.worker.js");
};